import React from 'react'

const KeyPoints = () => {
    const themeKeyPoints = [
        {
            name: "Be Ethical",
            title: "Ethical",
            path: "/assets/key-points/hand-sake.png",
            description: "Being ethical means acting with fairness and integrity. It ensures trust and credibility in every interaction."
        },
        {
            name: "Be Authentic",
            title: "Authenticity",
            path: "/assets/key-points/check-circle.png",
            description: "Being authentic means being true to who you are, without compromise. It builds trust and strengthens connections."
        },
        {
            name: "Be Responsible",
            title: "Responsible",
            path: "/assets/key-points/user-arrow.png",
            description: "Responsibility means owning your actions and decisions. It creates accountability and fosters respect."
        },
        {
            name: "Be Recognised",
            title: "Recognition",
            path: "/assets/key-points/ribbon.png",
            description: "Recognition celebrates contributions and achievements. It motivates individuals and builds stronger communities."
        }
    ]
    return (
        <section className="w-full bg-gradient-radial py-12 lg:py-24">
            <div className="container mx-auto px-4 lg:px-15">
                <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center mb-8 lg:mb-12">
                    FWPI Key Theme
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 justify-center items-center">
                    {
                        themeKeyPoints.map((pointDetails, index) => {
                            return (
                                <div key={index} className="group h-72 w-full rounded-xl [perspective:1000px] hover:scale-105 transition-transform duration-500">
                                    <div
                                        className="p-6 relative h-full w-full rounded-xl shadow-[0px_0px_7px_4px_rgba(171,198,248,0.5)] transition-all duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateX(-180deg)]">
                                        <div
                                            className="p-6 absolute inset-0 [backface-visibility:hidden] bg-white rounded-xl flex flex-col items-center text-center">
                                            <div className="p-6">
                                                <img className="w-32 h-32 lg:w-45 lg:h-45" src={pointDetails.path} alt={pointDetails.name} />
                                            </div>
                                            <h3 className="mt-4 text-black text-2xl sm:text-3xl lg:text-3xl font-semibold">{pointDetails.name}</h3>
                                        </div>
                                        <div
                                            className="absolute inset-0 [backface-visibility:hidden] bg-white rounded-xl flex flex-col items-center justify-center text-center [transform:rotateX(-180deg)] p-4">
                                            <h4 className="text-2xl font-semibold text-black">{pointDetails.name}</h4>
                                            <p className="mt-2 text-gray-600">{pointDetails.description}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default KeyPoints